export default "__VITE_ASSET__BqV$TU93__"